import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
// External library
import * as XLSX from 'xlsx';
// Modules
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Modules material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

export enum DisplayedTypes {
  default = 'Default',
  link = 'Link',
  date = 'Date',
  dobleObject = 'DobleObject',
  select = 'Select'
};

export interface DisplayedColumns { label: string; attr: string; attrSecond?: string, type?: DisplayedTypes };

@Component({
  selector: 'lib-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule
  ]
})
export class TableComponent {
  public objectColumns: any = [];
  public dataSource!: MatTableDataSource<any>;
  @Input() displayedColumns: Array<any> = [];

  @Input() set dataRow(data: any) {
    this.objectColumns = this.getNameAttr(this.displayedColumns);
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
  };

  // Angular material paginator
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  // Export table Excel
  @ViewChild("excelTable", { static: true }) excelTable!: ElementRef;
  @Input() exportExcel: Boolean = false;
  @Input() nameExcel: string = "defaultExcel";

  // Output select item
  @Output() itemSelectEvent$ = new EventEmitter<any>();

  constructor() { }

  getNameAttr(displayedColumns: DisplayedColumns[]) {
    return displayedColumns.map((value) => {
      return value.attr
    });
  }

  selectItem(item: any): void {
    this.itemSelectEvent$.emit(item);
  }

  exportexcel(): void {
    let element = this.excelTable.nativeElement;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, `${this.nameExcel}.xlsx`);

  }
}
